import { borderRadius, borderRadiusHalf, colors, MEDIA_QUERY } from "@farzoom/common-ui-components";
import { COLOR_VALUES } from "@theme";
import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  document: {
    background: colors.cardBackground,
    padding: 16,
    borderRadius,
    position: "relative",
    gap: 10,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    [MEDIA_QUERY.mobile]: {
      padding: 12,
      borderRadius: borderRadiusHalf,
      background: colors.grayLight,
    },
    "& + &": {
      marginTop: 10,
      [MEDIA_QUERY.mobile]: {
        marginTop: 16,
      },
    },
    "&.isError": {
      border: [1, "solid", colors.error],
    },
    "&.isDragged": {
      filter: "drop-shadow(1px 3px 1px #b5b5b5)",
    },
    "& $buttonAdd": {
      padding: "0 !important",
    },
  },
  wrapper: {
    flexGrow: 1,
    [MEDIA_QUERY.mobile]: {
      width: "calc(100% - 50px)",
    },
  },
  title: {
    fontSize: 15,
    lineHeight: 20 / 15,
    [MEDIA_QUERY.mobile]: {
      fontSize: 12,
      lineHeight: 18 / 12,
    },
  },
  buttonAdd: {},
  fileInput: {
    display: ["none", "!important"],
  },
  files: {
    marginTop: 8,
    display: "flex",
    flexDirection: "column",
    gap: 10,
    "& a": {
      marginRight: 4,
      [MEDIA_QUERY.mobile]: {
        marginLeft: 4,
      },
    },
  },
  file: {
    fontSize: 18,
    fontWeight: 500,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: 6,
    [MEDIA_QUERY.mobile]: {
      fontSize: 12,
      lineHeight: 1.2,
      fontWeight: 400,
      wordBreak: "break-word",
    },
    "& .anticon": {
      fontSize: 22,
    },
  },
  error: {
    marginBottom: 16,
    color: colors.error,
  },
  link: {
    color: colors.primaryColor,
    cursor: "pointer",
    lineHeight: 1.1,
    "& > span": {
      verticalAlign: "baseline",
    },
  },
  isFileSignedStyle: {
    color: colors.green,
    cursor: "pointer",
    lineHeight: 1.1,
  },
  isFileNotSignedStyle: {
    color: COLOR_VALUES.red,
    cursor: "pointer",
    lineHeight: 1.1,
  },
  fileSize: {
    fontSize: 12,
    lineHeight: 1.2,
    color: colors.coal3,
    marginLeft: 4,
    fontWeight: 700,
    "&:empty": {
      display: "none",
    },
    [MEDIA_QUERY.mobile]: {
      fontSize: 10,
    },
  },
});
